import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { AgreementApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  view_data: null,
  edit_data: null,
  bank_type_data: null,
  agreement_doc_types: null,
  invoice_mode_data: null
};

const AgreementSlice = createSlice({
  name: 'Agreement',
  initialState,
  reducers: {
    setAgreementGrid(state, action) {
      state.list_data = action.payload;
    },
    setAgreementView(state, action) {
      state.view_data = action.payload;
    },
    setAgreementEdit(state, action) {
      state.edit_data = action.payload;
    },
    setBankTypeGrid(state, action) {
      state.bank_type_data = action.payload;
    },
    setAgreementDocTypes(state, action) {
      state.agreement_doc_types = action.payload;
    },
    setInvoiceModeGrid(state, action) {
      state.invoice_mode_data = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Agreement List
export const getAgreementsList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.agreementList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAgreementGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAgreementGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Agreement List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Agreement List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Agreement View
export const getAgreementView = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.agreementView,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAgreementView(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAgreementView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Agreement View failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Agreement View exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Agreement Edit
export const getAgreemetEditData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.agreementEdit,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setAgreementEdit(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setAgreementEdit(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Agreement Edit failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Agreement Edit exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Save Agreement Bank Info
export const saveAgreementBankInfo = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.saveBankInfo,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || res?.description || 'Something went wrong'));
      console.error('❌ Save Agreement Bank Info failed ', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Save Agreement Bank Info exception ', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// bank type List
export const getBankTypeList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.banktypeList,
      method: 'get',
      payload: data
    });
    console.log('bank type list res', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setBankTypeGrid(res?.data ? res?.data?.summary?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setBankTypeGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Bank Type List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Bank Type List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Agreement Doc Types
export const getAgreementDocTypes = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.documentTypesBySource,
      method: 'get'
    });

    if (res?.success) {
      dispatch(setAgreementDocTypes(res?.data?.summary?.data || []));
      return res?.data;
    } else {
      dispatch(setAgreementDocTypes(null));
      dispatch(setApiError(res?.message || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Upload Agreement Document
export const uploadAgreementDoc = (data, token) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.uploadDocument,
      method: 'post',
      payload: data,
      extraHeaders: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    });

    if (res?.success) {
      // dispatch(setApiError('Document uploaded successfully!'));
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || res?.description || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// invoice mode list
export const getInvoiceModeList = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.invoiceModeList,
      method: 'get'
    });
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setInvoiceModeGrid(res?.data ? res?.data?.summary?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setInvoiceModeGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Update Agreement Billing
export const updateAgreementBilling = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: AgreementApi?.updateBilling,
      method: 'post',
      payload: data
    });

    if (res?.success) {
      return res?.data;
    } else {
      dispatch(setApiError(res?.message || res?.description || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const {
  setAgreementGrid,
  setAgreementView,
  setAgreementEdit,
  setBankTypeGrid,
  setAgreementDocTypes,
  setInvoiceModeGrid
} = AgreementSlice.actions;
export default AgreementSlice.reducer;
